const SkillBadge = ({ children, size, font }) => (
  <span className={`mph-light mph-primary  text-[0.6rem] sm:text-${size || 'xs '} font-${font || 'semibold'} px-2 py-1 rounded-full `}>
    {children}
  </span>
);
export default SkillBadge;
